import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';

import { routes } from '../../constants';

import MProjectCard from '../molecules/_molecules.project-card';

export default function OProjects({ items, className }) {
	const cName = !items.length ? 'o-hero-list-not-found' : '';
	let content = (
		<p className="not-found">
			<FormattedMessage id="NOT_FOUND.PROJECTS" defaultMessage="" />
		</p>);

	if (items.length) {
		content = items.map(item => (
			<MProjectCard
				key={get(item, 'uuid', '')}
				title={get(item, 'name', '')}
				img={get(item, 'cardImage.url', get(item, 'image.url', ''))}
				href={`${routes.INDUSTRIAL.HOME}${routes.PROJECT.replace(':slug', get(item, 'slug', ''))}`}
			/>
		));
	}

	return (

		<section className={`o-default-list ${className} ${cName}`}>
			{content}
		</section>
	);
}

OProjects.propTypes = {
	items: PropTypes.array.isRequired,
	className: PropTypes.string,
};

OProjects.defaultProps = {
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.projects.js